/**
 * [课程移动]
 * @author: Fu Xiaochun
 * @date: 2021-08-24 
 */

import React, { useState, useEffect, useRef } from 'react';
import styles from './LessionTypeModal.module.scss';
import PropTypes from 'prop-types';
import { message, Modal, Radio,  } from 'antd';
import * as api from '@/apis/client/school';

function LessionMoveModal(props){

    const $class = useRef(props.lession.pid);
    const [moveClass, setMoveClass] = useState(props.lession.pid);

    const onMoveclassChange = (e)=>{
        let val = e.target.value;
        $class.current = val;
        setMoveClass(val);
    };

    const onSave = ()=>{
        let id = props.lession.id;
        let pid = $class.current;
        api.moveLession({id, pid}).then(res=>{
            message.success('移动成功');
            props.onOk();
        }).catch(err=>{
            message.error(err.message);
        });
    };

    const onCancel = ()=>{
        props.onClose();
    };

    return (
        <Modal
            title='课程移动'
            centered={true}
            visible={true}
            onOk={onSave}
            onCancel={onCancel}
            okText="确认"
            cancelText="取消"
            bodyStyle={{padding: '10px 30px 30px 30px'}}
        >
            <div>
                <div className={styles.moveTitle}>移动至哪个分类</div>
                <Radio.Group onChange={onMoveclassChange} value={moveClass} style={{marginTop: '20px'}}>
                    {props.classList.map(v=><Radio style={{marginRight: '20px', marginBottom: '20px'}} key={v.id} value={v.id}>{v.name}</Radio>)}
                </Radio.Group>
            </div>
        </Modal>
    );
}

LessionMoveModal.propTypes = {
    history: PropTypes.object,
    match: PropTypes.object,
    classList: PropTypes.array,
    lession: PropTypes.object,
    onOk: PropTypes.func,
    onClose: PropTypes.func
};

export default LessionMoveModal;